/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_SearchInputs */

const id_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari jalur file`)
};

const ms_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari laluan fail`)
};

const da_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg i filstier`)
};

const de_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateipfade durchsuchen`)
};

const en_us2_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search file paths`)
};

const es_es2_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar rutas de archivos`)
};

const es_mx2_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar rutas de archivos`)
};

const fil_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap sa mga path ng file`)
};

const fr_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher dans les chemins de fichiers`)
};

const it_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca nei percorsi dei file`)
};

const hu_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés a fájlútvonalak között`)
};

const nl_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestandspaden doorzoeken`)
};

const no_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk i filbaner`)
};

const pl_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj w ścieżkach plików`)
};

const pt_br2_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar caminhos de arquivos`)
};

const pt_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar caminhos de ficheiros`)
};

const ro_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută în căile fișierelor`)
};

const fi_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae tiedostopoluista`)
};

const sv_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök i filsökvägar`)
};

const vi_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm đường dẫn tệp`)
};

const tr_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosya yollarında ara`)
};

const cs_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat v cestách souborů`)
};

const bg_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене в пътищата на файловете`)
};

const ru_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск по путям файлов`)
};

const uk_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук шляхів до файлів`)
};

const ar_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث في مسارات الملفات`)
};

const hi_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल पाथ खोजें`)
};

const th_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาเส้นทางไฟล์`)
};

const ja_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルパスを検索`)
};

const zh_cn2_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索文件路径`)
};

const zh_hant1_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋檔案路徑`)
};

const ko_builds_comparison_search = /** @type {(inputs: Builds_Comparison_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일 경로 검색`)
};

/**
* | output |
* | --- |
* | "Search file paths" |
*
* @param {Builds_Comparison_SearchInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_search = /** @type {((inputs?: Builds_Comparison_SearchInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_SearchInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_search(inputs)
	if (locale === "ms") return ms_builds_comparison_search(inputs)
	if (locale === "da") return da_builds_comparison_search(inputs)
	if (locale === "de") return de_builds_comparison_search(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_search(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_search(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_search(inputs)
	if (locale === "fil") return fil_builds_comparison_search(inputs)
	if (locale === "fr") return fr_builds_comparison_search(inputs)
	if (locale === "it") return it_builds_comparison_search(inputs)
	if (locale === "hu") return hu_builds_comparison_search(inputs)
	if (locale === "nl") return nl_builds_comparison_search(inputs)
	if (locale === "no") return no_builds_comparison_search(inputs)
	if (locale === "pl") return pl_builds_comparison_search(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_search(inputs)
	if (locale === "pt") return pt_builds_comparison_search(inputs)
	if (locale === "ro") return ro_builds_comparison_search(inputs)
	if (locale === "fi") return fi_builds_comparison_search(inputs)
	if (locale === "sv") return sv_builds_comparison_search(inputs)
	if (locale === "vi") return vi_builds_comparison_search(inputs)
	if (locale === "tr") return tr_builds_comparison_search(inputs)
	if (locale === "cs") return cs_builds_comparison_search(inputs)
	if (locale === "bg") return bg_builds_comparison_search(inputs)
	if (locale === "ru") return ru_builds_comparison_search(inputs)
	if (locale === "uk") return uk_builds_comparison_search(inputs)
	if (locale === "ar") return ar_builds_comparison_search(inputs)
	if (locale === "hi") return hi_builds_comparison_search(inputs)
	if (locale === "th") return th_builds_comparison_search(inputs)
	if (locale === "ja") return ja_builds_comparison_search(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_search(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_search(inputs)
	return ko_builds_comparison_search(inputs)
});
export { builds_comparison_search as "builds.comparison.search" }